import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {MsalService} from "@azure/msal-angular";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const msalService = inject(MsalService);
  let activeAccount = msalService.instance.getActiveAccount();
  if((req.url.includes("/rest/candidate-profile"))){
    req = req.clone({
      setHeaders: {
        Authorization : `Bearer ${activeAccount.idToken}`
      }
    });
  }
  return next(req);
};
